import { isStringArrayIncludes, distinct } from 'utilities/array';
import { getPropertyValues, findById } from 'utilities/collection';

const defaultProjection = ['profilePicture', 'fullName'];

class UsersStore {

  constructor(application, serverInterface) {

    this.requestsBuffer = [];
    this.nextCallTimerReference = null;
    this.store = {};

    this.application = application;
    this.serverInterface = serverInterface;

  }

  cloneUser(user) {

    const _user = {
      ...user
    };

    if (typeof user.profilePicture === 'object' && user.profilePicture !== null) {
      _user.profilePicture = {
        ...user.profilePicture
      };
    }

    return _user;

  }

  getStoreStatsByIdsAndProjection(userIds, projection) {

    const store = this.store;
    const users = [];
    const unavailableUserIds = [];

    for (let userId of userIds) {

      const data = store[userId];

      if (typeof data === 'undefined') {
        unavailableUserIds.push(userId);
        continue;
      }

      if (isStringArrayIncludes(data.projection, projection) === false) {
        unavailableUserIds.push(userId);
        continue;
      }

      users.push(this.cloneUser(data.user));

    }

    const result = {
      users,
      unavailableUserIds
    };

    return result;

  }

  storeUsers(users, projection) {

    const store = this.store;

    for (let user of users) {

      const userId = user._id;

      store[userId] = {
        user: this.cloneUser(user),
        projection: [...projection]
      };

    }

  }

  async fetchStartupUsersByIds(userIds, projection) {

    const filterOptions = {
      userIds: distinct(userIds)
    };
    const response = await this.serverInterface.startup.users.getPaginatedStartupUsersByQueryOptions({
      filterOptions,
      projection,
      paginationOptions: {
        skip: 0,
        limit: userIds.length
      }
    });

    return response.documents;

  }

  async getUsersByIds(userIds, projection = defaultProjection) {

    const stats = this.getStoreStatsByIdsAndProjection(userIds, projection);

    const users = stats.users;
    const unavailableUserIds = stats.unavailableUserIds;

    if (unavailableUserIds.length === 0) {
      return stats.users;
    }

    const _users = await this.fetchStartupUsersByIds(unavailableUserIds, projection);

    this.storeUsers(_users, projection);

    return [...users, ..._users];

  }

  async fetchUsers(projection) {

    const requestsBuffer = this.requestsBuffer;
    this.requestsBuffer = [];
    const userIds = getPropertyValues(requestsBuffer, 'userId');
    const users = await this.getUsersByIds(userIds, projection);

    for (let request of requestsBuffer) {

      const user = findById(users, request.userId);

      request.resolve(user);

    }

  }

  async getUserById(userId, projection = defaultProjection) {

    return new Promise(function resolver(resolve, reject) {

      clearTimeout(this.nextCallTimerReference);

      this.requestsBuffer.push({ userId, projection, resolve, reject });

      setTimeout(this.fetchUsers.bind(this, projection), 100);

    }.bind(this));

  }

}

export default UsersStore;